import { AdminLayout } from "@/views/layouts/AppLayout";
import { IntendedDemandPage } from "@/views/pages/purchasingManage/IntendedDemandPage";
import { IntendedDemandDetailPage } from "@/views/pages/purchasingManage/intendedDemand/intendDetail/IntendedDemandDetailPage";
import { IntendedDemandFormPage } from "@/views/pages/purchasingManage/intendedDemand/intendAdd/IntendedDemandFormPage";
import { PurchasingManagePage } from "@/views/pages/purchasingManage/PurchasingManagePage";
import { ProjectPage } from "@/views/pages/purchasingManage/project/ProjectPage";
import { ProjectDetailPage } from "@/views/pages/purchasingManage/project/info/ProjectDetailPage";
import { ContractPage } from "@/views/pages/purchasingManage/contract/ContractPage";
import { ContractFormPage } from "@/views/pages/purchasingManage/contract/add";
import { ContractInfoPage } from "@/views/pages/purchasingManage/contract/info/ContractInfoPage";
import { ProjectFormPage } from "@/views/pages/purchasingManage/project/add/ProjectFormPage";
import { ProjectAddCustomerPage } from "@/views/pages/purchasingManage/project/addCustomer/ProjectAddCustomerPage";
import { InvoiceManagementPage } from "@/views/pages/purchasingManage/invoiceManagement/InvoiceManagementPage";
import { InvoiceManagementDetailPage } from "@/views/pages/purchasingManage/invoiceManagement/detail/InvoiceManagementDetailPage";
import { PaymentPage } from "@/views/pages/purchasingManage/payment/PaymentPage";
import { DeliveryPage } from "@/views/pages/purchasingManage/delivery/DeliveryPage";
import { DeliveryDetailPage } from "@/views/pages/purchasingManage/delivery/detail/DeliveryDetailPage";
import { ReceiptManagementPage } from "@/views/pages/purchasingManage/receiptManagement/ReceiptManagementPage";
import { PurchaseReconciliationPage } from "@/views/pages/purchasingManage/purchaseReconciliation/PurchaseReconciliationPage";
import { PurchaseReconciliationDetailPage } from "@/views/pages/purchasingManage/purchaseReconciliation/detail/PurchaseReconciliationDetailPage";
import { ReceiptManagementDetailPage } from "@/views/pages/purchasingManage/receiptManagement/detail/ReceiptManagementDetailPage";
import { PaymentDetailPage } from "@/views/pages/purchasingManage/payment/detail/PaymentDetailPage";
import type { AdminRouteObject } from "../index";

/** 采购管理路由，首批接入 Vue 主入口和意向需求分页列表。 */
export const purchasingManageRoutes: AdminRouteObject = {
    path: "/purchasingManage",
    element: <AdminLayout />,
    handle: { title: "采购管理" },
    children: [
        { index: true, element: <PurchasingManagePage />, handle: { title: "采购管理" } },
        {
            path: "intendedDemand",
            element: <IntendedDemandPage />,
            handle: {
                title: "意向需求",
                permissions: ["ROLE_PURCHASE_DEMAND_R", "ROLE_PURCHASE_DEMAND_MANAGE", "ROLE_PURCHASE_DEMAND_DEAL"]
            }
        },
        {
            path: "intendedDemand/detail/:id",
            element: <IntendedDemandDetailPage />,
            handle: {
                title: "采购意向详情",
                permissions: ["ROLE_PURCHASE_DEMAND_R", "ROLE_PURCHASE_DEMAND_MANAGE", "ROLE_PURCHASE_DEMAND_DEAL"]
            }
        },
        {
            path: "intendedDemand/intendAdd",
            element: <IntendedDemandFormPage />,
            handle: { title: "新增采购意向", permissions: ["ROLE_PURCHASE_DEMAND_DEAL"] }
        },
        {
            path: "intendedDemand/intendAdd/:intendId",
            element: <IntendedDemandFormPage />,
            handle: { title: "编辑采购意向", permissions: ["ROLE_PURCHASE_DEMAND_DEAL"] }
        },
        {
            path: "project",
            element: <ProjectPage />,
            handle: {
                title: "采购项目",
                permissions: ["ROLE_PROJECT_R", "ROLE_PROJECT_MANAGE", "ROLE_PROJECT_DEAL"]
            }
        },
        {
            path: "project/info/:id",
            element: <ProjectDetailPage />,
            handle: { title: "项目详情", permissions: ["ROLE_PROJECT_R", "ROLE_PROJECT_MANAGE", "ROLE_PROJECT_DEAL"] }
        },
        {
            path: "project/add",
            element: <ProjectFormPage />,
            handle: { title: "新增项目", permissions: ["ROLE_PROJECT_DEAL"] }
        },
        {
            path: "project/addCustomer/:projectId",
            element: <ProjectAddCustomerPage />,
            handle: { title: "新增采购商", permissions: ["ROLE_PROJECT_DEAL"] }
        },
        {
            path: "contract",
            element: <ContractPage />,
            handle: {
                title: "采购合同",
                permissions: ["ROLE_PROJECT_R", "ROLE_PROJECT_DEAL"]
            }
        },
        {
            path: "contract/add",
            element: <ContractFormPage />,
            handle: { title: "新增合同", permissions: ["ROLE_PROJECT_DEAL"] }
        },
        {
            path: "contract/edit/:id",
            element: <ContractFormPage />,
            handle: { title: "编辑合同", permissions: ["ROLE_PROJECT_DEAL"] }
        },
        {
            path: "contract/info/:id",
            element: <ContractInfoPage />,
            handle: { title: "合同详情", permissions: ["ROLE_PROJECT_R", "ROLE_PROJECT_DEAL"] }
        },
        {
            path: "invoiceManagement",
            element: <InvoiceManagementPage />,
            handle: {
                title: "发票管理",
                permissions: ["ROLE_PURCHASE_INVOICE_R"]
            }
        },
        {
            path: "invoiceManagement/detail/:id",
            element: <InvoiceManagementDetailPage />,
            handle: { title: "开票详情", permissions: ["ROLE_PURCHASE_INVOICE_R"] }
        },
        {
            path: "payment",
            element: <PaymentPage />,
            handle: {
                title: "付款管理",
                permissions: ["ROLE_FUNDS_R", "ROLE_FUNDS_W"]
            }
        },
        {
            path: "payment/info/:id",
            element: <PaymentDetailPage />,
            handle: { title: "付款详情", permissions: ["ROLE_FUNDS_R", "ROLE_FUNDS_W"] }
        },
        {
            path: "delivery",
            element: <DeliveryPage />,
            handle: {
                title: "提货申请",
                permissions: ["ROLE_PROJECT_R"]
            }
        },
        {
            path: "delivery/detail/:id",
            element: <DeliveryDetailPage />,
            handle: { title: "提货详情", permissions: ["ROLE_PROJECT_R"] }
        },
        {
            path: "receiptManagement",
            element: <ReceiptManagementPage />,
            handle: { title: "签收管理", permissions: ["ROLE_PROJECT_R"] }
        },
        {
            path: "receiptManagement/detail/:id",
            element: <ReceiptManagementDetailPage />,
            handle: { title: "签收详情", permissions: ["ROLE_PROJECT_R"] }
        },
        {
            path: "purchaseReconciliation",
            element: <PurchaseReconciliationPage />,
            handle: { title: "采购对账", permissions: ["ROLE_PROJECT_R"] }
        },
        {
            path: "reconciliation/info/:id",
            element: <PurchaseReconciliationDetailPage />,
            handle: { title: "对账详情", permissions: ["ROLE_PROJECT_R"] }
        }
    ]
};

export default purchasingManageRoutes;
